module.exports = ":host /deep/ .mat-form-field-placeholder {\n  white-space: normal; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/monitoring/monitoring.component.scss
// module id = 1200
// module chunks = 0